"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KZFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_131)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_131`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#36B6CC"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 16.793C14.6509 16.793 16.8 14.644 16.8 11.993C16.8 9.34203 14.6509 7.19299 12 7.19299C9.34898 7.19299 7.19995 9.34203 7.19995 11.993C7.19995 14.644 9.34898 16.793 12 16.793Z",
					fill: "#FFD400"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 17.6491L10.0421 20.5754L9.54383 17.0877L6.51226 18.8772L7.57892 15.5228L4.07015 15.8175L6.48419 13.2561L3.19296 11.993L6.47717 10.7298L4.06313 8.16839L7.57191 8.46313L6.50524 5.10874L9.53682 6.8912L10.0351 3.40348L11.993 6.3298L13.9509 3.40348L14.4491 6.8912L17.4807 5.10874L16.414 8.46313L19.9228 8.16839L17.5158 10.7368L20.8 11.993L17.5158 13.2561L19.9298 15.8175L16.421 15.5228L17.4877 18.8772L14.4561 17.0947L13.9579 20.5824C13.9579 20.5754 12 17.6491 12 17.6491ZM12 17.593C15.0947 17.593 17.607 15.0807 17.607 11.9859C17.607 8.8912 15.0947 6.38594 12 6.38594C8.90524 6.38594 6.39296 8.89822 6.39296 11.993C6.39296 15.0877 8.90524 17.593 12 17.593ZM-4.40002 1.98594C-4.40002 1.76138 -4.2316 1.58594 -4.00002 1.58594H-3.20704C-2.98248 1.58594 -2.80704 1.75436 -2.80704 1.98594V2.77892C-2.80002 2.99646 -2.97546 3.17892 -3.20002 3.17892H-4.00002C-4.21757 3.17892 -4.40002 3.00348 -4.40002 2.78594V1.98594ZM-4.40002 5.19296C-4.40002 4.96839 -4.2316 4.79296 -4.00002 4.79296H-3.20704C-2.98248 4.79296 -2.80704 4.96138 -2.80704 5.19296V5.98594C-2.80002 6.20348 -2.97546 6.38594 -3.20002 6.38594H-4.00002C-4.21757 6.38594 -4.40002 6.2105 -4.40002 5.99296V5.19296ZM-4.40002 8.39296C-4.40002 8.16839 -4.2316 7.99296 -4.00002 7.99296H-3.20704C-2.98248 7.99296 -2.80704 8.16138 -2.80704 8.39296V9.18594C-2.80002 9.40348 -2.97546 9.58594 -3.20002 9.58594H-4.00002C-4.21757 9.58594 -4.40002 9.4105 -4.40002 9.19296V8.39296ZM-4.40002 11.593C-4.40002 11.3684 -4.2316 11.193 -4.00002 11.193H-3.20704C-2.98248 11.193 -2.80704 11.3614 -2.80704 11.593V12.3859C-2.80002 12.6035 -2.97546 12.7859 -3.20002 12.7859H-4.00002C-4.21757 12.7859 -4.40002 12.6105 -4.40002 12.393V11.593ZM-4.40002 14.8C-4.40002 14.5754 -4.2316 14.4 -4.00002 14.4H-3.20704C-2.98248 14.4 -2.80704 14.5684 -2.80704 14.8V15.593C-2.80002 15.8105 -2.97546 15.993 -3.20002 15.993H-4.00002C-4.21757 15.993 -4.40002 15.8175 -4.40002 15.6V14.8ZM-4.40002 18C-4.40002 17.7754 -4.2316 17.6 -4.00002 17.6H-3.20704C-2.98248 17.6 -2.80704 17.7684 -2.80704 18V18.793C-2.80002 19.0105 -2.97546 19.193 -3.20002 19.193H-4.00002C-4.21757 19.193 -4.40002 19.0175 -4.40002 18.8V18ZM-4.40002 21.2C-4.40002 20.9754 -4.2316 20.8 -4.00002 20.8H-3.20704C-2.98248 20.8 -2.80704 20.9684 -2.80704 21.2V21.993C-2.80002 22.2105 -2.97546 22.393 -3.20002 22.393H-4.00002C-4.21757 22.393 -4.40002 22.2175 -4.40002 22V21.2ZM-2.80002 19.6C-2.80002 19.3754 -2.6316 19.2 -2.40002 19.2H-1.60704C-1.38248 19.2 -1.20704 19.3684 -1.20704 19.6V20.393C-1.20002 20.6105 -1.37546 20.793 -1.60002 20.793H-2.40002C-2.61757 20.793 -2.80002 20.6175 -2.80002 20.4V19.6ZM-2.80002 16.4C-2.80002 16.1754 -2.6316 16 -2.40002 16H-1.60704C-1.38248 16 -1.20704 16.1684 -1.20704 16.4V17.193C-1.20002 17.4105 -1.37546 17.593 -1.60002 17.593H-2.40002C-2.61757 17.593 -2.80002 17.4175 -2.80002 17.2V16.4ZM-2.80002 13.193C-2.80002 12.9684 -2.6316 12.793 -2.40002 12.793H-1.60704C-1.38248 12.793 -1.20704 12.9614 -1.20704 13.193V13.9859C-1.20002 14.2035 -1.37546 14.3859 -1.60002 14.3859H-2.40002C-2.61757 14.3859 -2.80002 14.2105 -2.80002 13.993V13.193ZM-2.80002 9.99296C-2.80002 9.76839 -2.6316 9.59295 -2.40002 9.59295H-1.60704C-1.38248 9.59295 -1.20704 9.76138 -1.20704 9.99296V10.7859C-1.20002 11.0035 -1.37546 11.1859 -1.60002 11.1859H-2.40002C-2.61757 11.1859 -2.80002 11.0105 -2.80002 10.793V9.99296ZM-2.80002 6.79296C-2.80002 6.56839 -2.6316 6.39296 -2.40002 6.39296H-1.60704C-1.38248 6.39296 -1.20704 6.56138 -1.20704 6.79296V7.58594C-1.20002 7.80348 -1.37546 7.98594 -1.60002 7.98594H-2.40002C-2.61757 7.98594 -2.80002 7.8105 -2.80002 7.59296V6.79296ZM-2.80002 3.59296C-2.80002 3.36839 -2.6316 3.19296 -2.40002 3.19296H-1.60704C-1.38248 3.19296 -1.20704 3.36138 -1.20704 3.59296V4.38594C-1.20002 4.60348 -1.37546 4.78594 -1.60002 4.78594H-2.40002C-2.61757 4.78594 -2.80002 4.6105 -2.80002 4.39296V3.59296Z",
					fill: "#FFD400"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_131`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KZFlag };
